import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as", "color", "orientation", "classes"];
import React from 'react';
import classNames from 'classnames/bind';
import { cssUtils } from "../internal/CssUtils";
import styles from './Divider.css';
var cx = classNames.bind(styles);
export var Divider = function Divider(_ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'hr' : _ref$as,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'N50' : _ref$color,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cx('root', "".concat(cssUtils("backgroundColor_".concat(color))), orientation, classes.root)
  }, props));
};
export default Divider;